import React from 'react';

export default ({title, content}) => {
  return (
    <div className="prompt-when-sys-die">
      <div className="prompt-container">
        <div className="prompt-title">{title}</div>
        <p className="prompt-message" dangerouslySetInnerHTML={{__html: content}} />
        <div className="post-copy">
          <span>International SOS Email Alert Subscription Platform @ 2016 - 2018</span>
          <span className="powered-by">Powered by <a href="https://oxone.io" target="_blank">Oxone.io</a></span>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/component/maintenance.js